var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVfluLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 606,
    height: 328,
    viewBox: "0 0 606 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_307_27",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 0,
    width: 605,
    height: 324
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.66483 66.5046L602.309 0V322.212L-1.66483 323.324V66.5046Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_307_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3533 323.17L2.46359 66.0063L63.7402 59.26L93.8242 191.848L108.885 268.433L111.829 268.357L127.234 190.008L157.7 48.9106L216.033 42.4709L148.144 323.017L70.3533 323.17Z",
    fill: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1484 319.49L160.3 33.1181L339.733 30.2816L327.807 84.9419L205.062 84.2519L189.084 152.941L298.602 156.315L286.675 209.595L177.157 204.114L148.22 324.665L91.1102 319.529H91.1484V319.49Z",
    fill: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 13.4543V209.097C479.603 218.833 479.832 227.841 480.329 236.082C481.056 244.016 482.547 250.763 484.725 256.321C487.172 261.879 490.727 266.248 495.352 269.392C500.016 272.266 506.361 273.646 514.427 273.493C522.493 273.34 528.877 271.73 533.502 268.625C538.166 265.214 541.568 260.614 543.785 254.826C546.231 249.038 547.684 242.023 548.181 233.859C548.907 225.387 549.289 216.15 549.289 206.145V5.78802L604.335 -0.268311V194.684C604.335 216.878 603.112 236.312 600.666 252.986C598.448 269.622 594.052 283.536 587.439 294.652C580.826 305.73 571.652 314.009 559.916 319.529C548.181 325.01 533.005 327.732 514.427 327.732C495.849 327.732 480.673 325.087 468.938 319.797C457.203 314.546 448.028 306.726 441.415 296.3C434.802 285.912 430.291 272.918 427.845 257.356C425.628 241.793 424.557 223.586 424.557 202.734V19.5489L479.603 13.4926V13.4543Z",
    fill: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.449 322.71V30.665L378.877 24.5703V270.082L488.969 267.782V322.404L323.449 322.71Z",
    fill: "#252422"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 606,
    height: 328,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVfluLogo1);
export default __webpack_public_path__ + "static/media/vflu_logo_1.c85af03990af1dd5482a25ce34e70efb.svg";
export { ForwardRef as ReactComponent };